var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    _c("hr", {
      staticStyle: {
        "flex-basis": "100%",
        height: "0",
        margin: "0",
        border: "0",
      },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "form-group-material col-3" }, [
          _c("p", { staticClass: "title text-light-gray mb-2 mb-lg-0" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.$t("global.words.subject")) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.email.subject,
                expression: "email.subject",
              },
            ],
            staticClass: "material-input checklist-new-item",
            attrs: { id: "email-subject", type: "text" },
            domProps: { value: _vm.email.subject },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.email, "subject", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "d-none", attrs: { for: "email-subject" } },
            [_vm._v(_vm._s(_vm.$t("e-sign-package.emailSubject")))]
          ),
        ]),
        _vm._v(" "),
        _vm.editing
          ? _c("div", { staticClass: "form-group-material col-3" }, [
              _c("p", { staticClass: "title text-light-gray mb-2 mb-lg-0" }, [
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("email.from")) + "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("input", {
                staticClass: "material-input disabled checklist-new-item",
                attrs: { id: "email-from", disabled: "", type: "text" },
                domProps: { value: _vm.owner.email },
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "d-none", attrs: { for: "email-from" } },
                [
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("email.from")) + "\n        "
                  ),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-group-material col-3 d-flex align-items-end" },
          [
            !_vm.referrerEmail
              ? _c("dropdown", {
                  attrs: {
                    "value-only": "",
                    placeholder: _vm.$t("automations.coApplicantEmailOptions"),
                    items: _vm.coapplicantOptions,
                  },
                  model: {
                    value: _vm.email.coapplicantOption,
                    callback: function ($$v) {
                      _vm.$set(_vm.email, "coapplicantOption", $$v)
                    },
                    expression: "email.coapplicantOption",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.emailSynced
      ? _c(
          "div",
          { staticClass: "automation-email justify-content-center w-100" },
          [
            _c(
              "div",
              { staticClass: "row flex-sm-nowrap" },
              [
                _c("email-editor", {
                  ref: "emailEditor",
                  staticClass: "col-12 col-sm-8",
                  attrs: {
                    "email-signature": _vm.emailSignature,
                    "email-body": _vm.email.body,
                    height: "10vw",
                    "show-merge-tags": true,
                    "substitution-hints": true,
                    attachments: false,
                    "show-application-merge-tags": false,
                  },
                  on: { change: _vm.handleEditorChange },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "side-controls col-12 col-sm-4" }, [
                  _c("div", [
                    _c("div", [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("automations.emailEditorSubstitutions")
                          ) +
                          ":\n            "
                      ),
                      _c("div", { staticClass: "row email-tags" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("automations.substitutionsClient")) +
                            ":\n              "
                        ),
                        _c(
                          "ul",
                          _vm._l(_vm.clientTags, function (ref) {
                            var tag = ref.tag
                            var description = ref.description
                            return _c("li", { key: tag }, [
                              _c("button", {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip",
                                    value: {
                                      title: description,
                                    },
                                    expression:
                                      "{\n                      title: description\n                    }",
                                  },
                                ],
                                staticClass: "clickable",
                                domProps: { textContent: _vm._s(tag) },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleTag(tag)
                                  },
                                },
                              }),
                            ])
                          }),
                          0
                        ),
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t("automations.substitutionsReferrer")
                            ) +
                            ":\n              "
                        ),
                        _c(
                          "ul",
                          _vm._l(_vm.referrerTags, function (ref) {
                            var tag = ref.tag
                            var description = ref.description
                            return _c("li", { key: tag }, [
                              _c("button", {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip",
                                    value: {
                                      title: description,
                                    },
                                    expression:
                                      "{\n                      title: description\n                    }",
                                  },
                                ],
                                staticClass: "clickable",
                                domProps: { textContent: _vm._s(tag) },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleTag(tag)
                                  },
                                },
                              }),
                            ])
                          }),
                          0
                        ),
                      ]),
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t(
                              "automations.clickingWillInsertSubstitutions"
                            )
                          ) +
                          "\n          "
                      ),
                    ]),
                  ]),
                ]),
              ],
              1
            ),
          ]
        )
      : _c("div", { staticClass: "container p-5 w-100" }, [
          _c("div", { staticClass: "row mb-4" }, [
            _c("div", { staticClass: "col d-flex justify-content-center" }, [
              _c("i", {
                staticClass: "fa fa-4x fa-exclamation-circle",
                staticStyle: { color: "red" },
                attrs: { "aria-hidden": "true" },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-4" }, [
            _c("div", { staticClass: "col d-flex justify-content-center" }, [
              _c("h3", { staticClass: "bold" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("automations.noEmailSynced")) +
                    "\n        "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col d-flex justify-content-center" }, [
              _c("p", { staticClass: "bold text-center" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("automations.clickToSetupSync")) +
                    "\n        "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col d-flex justify-content-center" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-sm",
                  on: {
                    click: function ($event) {
                      return _vm.goToSettings()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t("settings.accountTab.tabs.emailPreferences")
                      ) +
                      "\n        "
                  ),
                ]
              ),
            ]),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }